<template>
  <div class="uncompleteOrder">
    <!-- 下拉刷新提示 -->
    <div
      v-if="distance > 0"
      :style="{ height: distance + 'px' }"
      class="pull_refresh"
    >
      <p>
        <van-loading size="18" v-if="pullStatus == 2" /><span>{{
          pullTexts[pullStatus]
        }}</span>
      </p>
    </div>
    <!-- 内容 -->
    <div @touchstart="touchStart" @touchend="touchEnd" @touchmove="touchMove">
      <!-- 步骤条 -->
      <van-sticky :offset-top="isiOSX ? '88px' : '68px'">
        <div class="progressBar" :class="{ upMove: isUpMove }">
          <div
            v-for="(item, index) of progressBarData"
            :key="index"
            @click="toProgress(index)"
          >
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/active.png"
              v-if="index + 1 == activeProgress"
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/1.png"
              v-if="
                index == 0 && index >= progress && index + 1 != activeProgress
              "
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/2.png"
              v-if="
                index == 1 && index >= progress && index + 1 != activeProgress
              "
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/3.png"
              v-if="
                index == 2 && index >= progress && index + 1 != activeProgress
              "
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/4.png"
              v-if="
                index == 3 && index >= progress && index + 1 != activeProgress
              "
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/11.png"
              v-if="
                index == 0 && index < progress && index + 1 != activeProgress
              "
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/22.png"
              v-if="
                index == 1 && index < progress && index + 1 != activeProgress
              "
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/33.png"
              v-if="
                index == 2 && index < progress && index + 1 != activeProgress
              "
              alt=""
            />
            <img
              class="progressBarTop"
              src="./../../../../assets/decoration/order/44.png"
              v-if="
                index == 3 && index < progress && index + 1 != activeProgress
              "
              alt=""
            />
            <span
              class="progressBarBtm"
              :class="{
                checkedBtm: index < progress,
                activeBtm: index + 1 == activeProgress,
              }"
              >{{ item }}</span
            >
            <img
              class="line"
              src="./../../../../assets/decoration/order/step1.png"
              v-if="index + 1 < progressBarData.length && index + 1 >= progress"
              alt=""
            />
            <!-- <img class="line" src="./../../../assets/decoration/order/step2.png" v-if="index + 1 < progressBarData.length" alt=""> -->
            <img
              class="line"
              src="./../../../../assets/decoration/order/step3.png"
              v-if="index + 1 < progressBarData.length && index + 1 < progress"
              alt=""
            />
          </div>
        </div>
      </van-sticky>

      <!-- 内容 -->
      <!-- 1 -->
      <First
        v-if="activeProgress == 1"
        @nextStep="nextStep()"
        :progress="progress"
        :id="id"
      ></First>
      <!-- 2 -->
      <Second
        v-if="activeProgress == 2"
        :progress="progress"
        :id="id"
        @nextStep="nextStep()"
      ></Second>
      <!-- 3 -->
      <Third
        v-if="activeProgress == 3"
        :progress="progress"
        :id="id"
        @nextStep="nextStep()"
      ></Third>
      <!-- 4 -->
      <Fourth
        v-if="activeProgress == 4"
        :progress="progress"
        :id="id"
        :order_sn="order_sn"
        ref="fourth"
      ></Fourth>
    </div>
  </div>
</template>
<script>
import First from "./first.vue";
import Second from "./second.vue";
import Third from "./third.vue";
import Fourth from "./fourth.vue";
export default {
  props: {
    id: {
      default: "",
    },
    order_sn: {
      default: "",
    },
  },
  data() {
    return {
      isiOSX: false,
      progressBarData: [
        "确认基础信息",
        "完善房屋信息",
        "上传缴费凭证",
        "签署合同",
      ],
      progress: 0, //实际进度
      activeProgress: 0, //当前位置
      isUpMove: false,
      startPosition: 0, // 触摸开始位置
      distance: 0, // 下拉距离
      pullStatus: 0, // 0下拉即可刷新  1松手即可刷新  2加载中 3加载完毕
      pullTexts: ["下拉即可刷新哦~", "松手刷新~", "加载中...", "加载完毕"],
    };
  },
  components: { First, Second, Third, Fourth },
  mounted() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getOrderProgress();
    window.addEventListener("scroll", this.listenerScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.listenerScroll);
  },
  methods: {
    // 监听进度条
    listenerScroll(e) {
      if (
        e.srcElement.scrollingElement &&
        e.srcElement.scrollingElement.scrollTop
      ) {
        let top = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
        if (top > 20) {
          this.isUpMove = true;
        } else {
          this.isUpMove = false;
        }
      }
    },
    //   获取订单进度
    getOrderProgress(type) {
      this.$api
        .post("decoration/member/order/flow", {
          order_id: this.id,
        })
        .then((res) => {
          this.progress = res.flow_id;
          this.activeProgress = this.progress;
          //   下拉刷新设置为成功
          this.pullStatus = 3;
          this.distance = 0;
          //   如果是下拉刷新且进度为4，则刷新合同列表
          if (type == "refresh" && this.progress == 4) {
            this.$refs.fourth.getData();
          }
        });
    },
    toProgress(index) {
      if (index < this.progress) {
        this.isUpMove = false;
        this.activeProgress = index + 1;
      }
    },
    nextStep() {
      //   刷新订单进度
      this.getOrderProgress();
    },
    touchStart(e) {
      this.startPosition = e.touches[0].pageY;
    },
    touchMove(e) {
      // 获取一下当前滚动条的位置
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条在顶部的时候才认定为下拉操作
      if (scrollTop < 1 && this.distance < 70) {
        // 获取开始和结束位置的 差
        let distance = e.touches[0].pageY - this.startPosition;
        // 差值大于0 代表从上往下滑，才允许操作
        if (distance > 0) {
          // 阻止默认事件,极其重要，不加的话部分浏览器 页面无法滑动 or 滑动时闪烁 or....，可以使用移动端微信浏览器测试效果
          e.preventDefault();
          // 判断移动一个距离，超过这个距离松手 执行 刷新操作
          if (distance < 70) {
            // 将计算得来的差值赋值，以使页面向下移动
            this.pullStatus = 0;
            this.distance = distance;
          } else {
            this.pullStatus = 1;
            this.distance = distance;
          }
        }
      }
    },
    touchEnd(e) {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 在结束时，需要判断一下状态和下拉的距离，符合要求才执行下拉的操作
      if (scrollTop <= 1 && this.distance >= 70) {
        this.pullStatus = 2;
        // 下拉刷新
        this.getOrderProgress("refresh");
      } else {
        //   不是下拉刷新
        this.distance = 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.uncompleteOrder {
  min-height: 100%;
  .pull_refresh {
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #969799;
      font-size: 14px;
      span {
        margin-left: 12px;
      }
    }
  }
  .progressBar {
    padding: 11px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f5f6ff;
    div {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .progressBarTop {
        width: 32px;
        height: 32px;
      }
      .progressBarBtm {
        margin-top: 6px;
        font-size: 12px;
        font-weight: 500;
        color: #999999;
      }
      .checkedBtm {
        color: #333333;
      }
      .activeBtm {
        color: #5853e9;
        font-weight: bold;
      }
      .line {
        width: 47px;
        position: absolute;
        right: -23.5px;
        top: 16px;
      }
    }
  }
  .upMove {
    // border: 1px solid red;
    box-shadow: 0px 3px 3px 0px rgba(215, 218, 244, 0.63);
  }
}
</style>
